import { render, staticRenderFns } from "./CalendarWidget.vue?vue&type=template&id=0597c3e4&scoped=true"
import script from "./CalendarWidget.js?vue&type=script&lang=js&external"
export * from "./CalendarWidget.js?vue&type=script&lang=js&external"
import style0 from "./CalendarWidget.vue?vue&type=style&index=0&id=0597c3e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0597c3e4",
  null
  
)

export default component.exports